import { render } from "./EffectSelectVue.vue?vue&type=template&id=712b17cf&ts=true"
import script from "./EffectSelectVue.vue?vue&type=script&lang=ts"
export * from "./EffectSelectVue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__